<template>
  <div>
    <div class="w-full justify-end items-center mb-3">
      <div class="flex items-center space-x-2">
        <button class="px-2.5 py-1 bg-gray-50 hover:bg-gray-100 border border-solid border-gray-200 rounded">
          <input type="checkbox" v-model="transfer_to_is_selected" />
          <span>Transfer to</span>
        </button>
        <button class="px-2.5 py-1 bg-gray-50 hover:bg-gray-100 border border-solid border-gray-200 rounded">
          <input type="checkbox" v-model="invite_to_is_selected" />
          <span>Invite CoTeacher</span>
        </button>
        <div v-if="transfer_to_is_selected || invite_to_is_selected" class="w-96">
          <input type="text" class="w-full px-1.5 py-1 border border-solid border-gray-200 rounded" :placeholder="transfer_to_is_selected === true ? 'Enter teacher email to transfer the courses...' : 'Enter teacher email to invite him for the courses...'" v-model="user_email">
        </div>
        <button @click="handleClick(transfer_to_is_selected === true ? 'transfer' : 'invite')" v-if="transfer_to_is_selected || invite_to_is_selected" class="px-2.5 py-1 bg-primary border border-solid border-primary hover:bg-primary-dark text-white rounded">
          <span>{{ transfer_to_is_selected === true ? 'Transfer Courses' : 'Invite' }}</span>
        </button>
      </div>
    </div>
    <div class="details-list">
      <div class="detail-item">
        <span class="b course-header">Name & Section</span>
        <div class="col-xs-8 flex justify-between row">
          <span class="col-xs-4 b course-header">Status</span>
          <span class="col-xs-3 b course-header">Students</span>
          <span class="col-xs-2 b course-header">Written</span>
          <span class="col-xs-1 b course-header">Verbal</span>
        </div>
      </div>
      <div class="detail-item" v-for="(course, index) in user.courses" :key="index">
        <div :class="course.teachers.includes(getProfile.id) || getCurrentSchool.id === course.school_id || systemWide ? 'portfolio-link cursor-pointer' : 'not-clickable'" class="text-left flex items-center space-x-2">
          <div>
            <input v-model="selectedCourses" :value="course.id" @change="handleSelection(course.id)" type="checkbox">
          </div>
          <a class="flex" @click="goToCourse(course)" :href="course.link" target="_blank">
            {{ course.title }}
            <i v-if="course.teachers.includes(getProfile.id) || getCurrentSchool.id === course.school_id || systemWide" class="fas fa-external-link-alt"></i>
          </a>
        </div>
        <div class="col-xs-8 flex justify-between row">
          <span class="col-xs-4 tc">
            {{ course.is_archived ? 'Archived' : 'Active' }}
          </span>
          <span class="col-xs-3 tc">
            {{ course.number_students }}
          </span>
          <span class="col-xs-2 tc">
            {{ course.count_roundtable }}
          </span>
          <span class="col-xs-1 tc">
            {{ course.count_live }}
          </span>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
  import courseDetailsService from 'services/courses';
  import { EventBus } from 'utils/event-bus';
  import URLconfigs from 'services/apiConfigs';
  import { mapGetters } from 'vuex';
  import Axios from 'axios';

  export default {
    data() {
      return {
        selectedCourses: [],
        is_checked: false,
        selected_id: null,
        transfer_to_is_selected: false,
        invite_to_is_selected: false,
        user_email: ''
      };
    },
    watch: {
      transfer_to_is_selected(newValue) {
        if (newValue === true && this.invite_to_is_selected === true) {
          this.invite_to_is_selected = false;
        }
      },
      invite_to_is_selected(newValue) {
        if (newValue === true && this.transfer_to_is_selected === true) {
          this.transfer_to_is_selected = false;
        }
      }
    },
    props: {
      user: {
        type: Object,
        default() {
          return {};
        },
      },
      systemWide: {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    computed: {
      ...mapGetters(['getProfile', 'getCurrentSchool']),
      school_id() {
        return this.systemWide ? this.user.schoolID : this.getCurrentSchool.id;
      },
    },
    methods: {
      handleClick: async function(type) {
        if (type === 'invite') {
          await Axios.post(`api/courses/add_co_teacher_to_courses`, {
            co_teacher_email: this.user_email,
            courses: this.selectedCourses,
            send_email_notification: false,
          });
          this.selectedCourses = [];
        }
        if (type === 'transfer') {
          await Axios.post(`api/courses/transfer_courses`, {
            email_to_transfer: this.user_email,
            courses: this.selectedCourses,
            user_from: this.user.id,
          });
          this.selectedCourses = [];
        }
      },
      handleSelectCourse: async function(course_id) {
        if (this.selectedCourses.includes(course_id)) {
          const index = this.selectedCourses.indexOf(course_id);
          this.selectedCourses.splice(index, 1);
        } else {
          this.selectedCourses.push(course_id);
        }
      },
      goToCourse(course) {
        //school admin/course can only navigate to course if it belongs to the school
        // or he is already a part  of the course
        let school_id = course.school_id
          ? course.school_id
          : this.getCurrentSchool.id;
        school_id = school_id === '' ? null : school_id;
        if (
          course.teachers.includes(this.getProfile.id) ||
          this.getCurrentSchool.id === course.school_id ||
          this.systemWide
        ) {
          courseDetailsService
            .createAdminSubscription(course.id, {
              school_id,
            })
            .then(() => {
              const url = `${URLconfigs.uiURL}/classes/${course.id}?page=1`;
              window.open(url, '_blank');
            })
            .catch(() => {
              EventBus.$emit(
                'toast-msg',
                'Something went wrong...Please try again.'
              );
            });
        }
      },
    },
    mounted() {},
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus'

  .details-list
    overflow-y: scroll
    overflow-x: hidden
    max-height: 60vh
    .detail-item
      display flex
      justify-content space-between
      padding .5rem 1rem
      border-bottom 1px solid pl-fog
    .portfolio-link
      a
        color: #78BEC8
        i
          align-self start
          font-size 6px
          padding 4px
    .not-clickable
      a
        color: #78BEC8
        &:hover
          text-decoration none  !important
    .course-header
      font-size 12px
      text-align center
  ::-webkit-scrollbar {
    display: block;
    width: 10px
    -webkit-appearance: none;
  }
</style>



// WEBPACK FOOTER //
// coursesTabContent.vue?1d5c5990